import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetUserRolesMutation } from '../apis';
import type { UserRoleQueryLinkerSchema } from '../schemas';

export function UserRolesSelect({ disabled, itemToString, ...props }: FormComboboxProps<UserRoleQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: UserRoleQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/user-roles/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={itemToString ?? getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetUserRolesMutation}
      disabled={disabled}
    />
  );
}
